import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { FlatButton, RaisedButton, TextField, SelectField, MenuItem, DatePicker, Checkbox, AutoComplete } from 'material-ui';
import { cyan500 } from 'material-ui/styles/colors';
import { defaultCreateModel } from 'src/models/TaskCreate';
import TaskApi from 'src/services/TaskApi';
import { TASK_CREATED } from 'src/constants/messages';
import { TASK_CREATE_ERROR } from 'src/constants/errors';
import { parseNumber } from 'src/utils/parsing';
import BoardyDialog from 'src/components/BoardyDialog';
import { toLocaleDate, todayString } from 'src/utils/dates';
import 'src/css/taskform.css';
var styles = {
    title: {
        backgroundColor: cyan500,
        color: 'white',
        marginBottom: '1rem'
    },
    action: {
        marginRight: '1rem',
        color: 'white',
    },
    datetime: {
        width: '100%'
    },
    text: {
        width: '100%',
    },
    select: {
        width: '100%',
    }
};
var defaultState = {
    busy: false,
    date: new Date(),
    hours: '',
    model: null,
    project: 1,
    projectName: '',
    product: 1,
    competency: 1,
    ticketType: 1,
    name: '',
    description: '',
    note: '',
    periodic: false
};
var validState = function (state) {
    return (!state.busy &&
        !!state.name &&
        !!state.date &&
        parseNumber(state.hours.toString()) > 0 &&
        state.project > 1 &&
        state.ticketType > 1 &&
        state.competency > 1);
};
var toMenuItem = function (item) { return (React.createElement(MenuItem, { key: item.id, value: item.id, primaryText: item.name })); };
var DialogSprintTitle = function (sprint) {
    var style = {
        display: 'flex',
        alignSelf: 'center'
    };
    var displayDate = function (date) { return todayString(new Date(date))
        .substring(5); };
    return (React.createElement("div", { style: style },
        React.createElement("small", null,
            "Sprint: ",
            displayDate(sprint.start),
            " - ",
            displayDate(sprint.end))));
};
var DropDownTrigger = function () { return (React.createElement("div", { style: { borderBottom: '1px solid #ddd' }, dangerouslySetInnerHTML: { __html: "\n    <button style=\"border: 10px none; box-sizing: border-box; display: inline-block; font-family: Roboto, sans-serif; cursor: pointer; text-decoration: none; margin: 0px; padding: 12px; outline: currentcolor none medium; font-size: 0px; font-weight: inherit; overflow: visible; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; width: 48px; height: 43px; fill: rgb(224, 224, 224); right: 0px; top: 8px; background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;\" tabindex=\"0\" type=\"button\">\n        <div>\n            <span style=\"height: 100%; width: 100%; position: absolute; top: 0px; left: 0px; overflow: hidden; pointer-events: none; z-index: 1;\"></span>\n            <svg style=\"display: inline-block; color: rgba(0, 0, 0, 0.87); fill: inherit; height: 24px; width: 24px; user-select: none; transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;\" viewBox=\"0 0 24 24\">\n                <path d=\"M7 10l5 5 5-5z\"></path>\n            </svg>\n        </div>\n    </button>" } })); };
var TaskForm = /** @class */ (function (_super) {
    tslib_1.__extends(TaskForm, _super);
    function TaskForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var payload, task;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ busy: true });
                        payload = tslib_1.__assign({}, this.state, { hours: parseNumber(this.state.hours.toString()) });
                        delete payload['model'];
                        return [4 /*yield*/, TaskApi.createModel(this.props.userStore.userId, payload)];
                    case 1:
                        task = _a.sent();
                        if (task) {
                            this.props.userStore.notify(TASK_CREATED);
                            this.props.taskStore.addTask(task);
                            this.setState(defaultState, function () { return _this.props.closed(); });
                        }
                        else {
                            this.props.userStore.notify(TASK_CREATE_ERROR);
                        }
                        this.setState({ busy: false });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleClose = function () {
            _this.setState(defaultState, function () { return _this.props.closed(); });
        };
        _this.state = Object.assign({}, defaultState);
        return _this;
    }
    TaskForm.prototype.componentWillReceiveProps = function (nextProps) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var model;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!nextProps.isOpen) return [3 /*break*/, 2];
                        return [4 /*yield*/, TaskApi.getCreateModel(this.props.userStore.userId)];
                    case 1:
                        model = _a.sent();
                        this.setState({ model: model });
                        return [3 /*break*/, 3];
                    case 2:
                        this.setState(defaultState);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TaskForm.prototype.handleChange = function (key, value) {
        var _a;
        var mutation = (_a = {},
            _a[key] = value,
            _a);
        this.setState(mutation);
    };
    TaskForm.prototype.clear = function () {
        this.setState(defaultState);
    };
    Object.defineProperty(TaskForm.prototype, "actions", {
        get: function () {
            return [
                React.createElement(RaisedButton, { key: "create", className: "primary", primary: true, style: styles.action, onClick: this.handleSubmit, disabled: !validState(this.state) }, "R\u00F6gz\u00EDt\u00E9s"),
                React.createElement(FlatButton, { key: "close", onClick: this.handleClose }, "M\u00E9gse")
            ];
        },
        enumerable: true,
        configurable: true
    });
    TaskForm.prototype.render = function () {
        var _this = this;
        if (!this.props.projectStore.configuration) {
            return null;
        }
        var sprint = this.props.projectStore.configuration.currentSprint;
        var _a = this.state.model || defaultCreateModel, projects = _a.projects, products = _a.products, competencies = _a.competencies, ticketTypes = _a.ticketTypes;
        return (React.createElement(BoardyDialog, { open: this.props.isOpen, onClosing: function () { return _this.props.closed(); }, title: "Egy\u00E9b feladatok r\u00F6gz\u00EDt\u00E9se", titleContent: DialogSprintTitle(sprint), actions: this.actions },
            React.createElement("form", { style: { padding: '1rem' } },
                React.createElement(TextField, { autoFocus: true, style: styles.text, floatingLabelFixed: true, floatingLabelText: "Megnevez\u00E9s", multiLine: true, onChange: function (e, value) { return _this.handleChange("name", value); } }),
                React.createElement(DatePicker, { inputStyle: styles.datetime, textFieldStyle: styles.datetime, style: styles.datetime, autoOk: true, disableYearSelection: true, minDate: new Date(sprint.start), maxDate: new Date(sprint.end), floatingLabelText: "Kezd\u00E9s", value: this.state.date, okLabel: "OK", cancelLabel: "M\u00E9gse", onChange: function (e, date) { return _this.handleChange("date", toLocaleDate(date)); } }),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, type: "number", floatingLabelText: "Id\u0151tartam (\u00F3ra)", multiLine: true, value: this.state.hours, onChange: function (e, value) { return _this.handleChange("hours", value.replace(/[^0-9,.]/g, '')); } }),
                React.createElement("div", { style: { display: 'flex', alignItems: 'baseline' } },
                    React.createElement(AutoComplete, { value: this.state.projectName, defaultValue: '', style: styles.select, fullWidth: true, floatingLabelFixed: true, openOnFocus: true, floatingLabelText: "Projekt", filter: function (searchText, key) { return key.toLowerCase().includes(searchText.toLowerCase()); }, menuStyle: { maxHeight: '350px' }, dataSource: projects.map(function (i) { return i.name; }), onNewRequest: function (value) {
                            var project = projects.find(function (i) { return i.name === value; });
                            if (project) {
                                _this.handleChange("project", project.id);
                                _this.setState({ projectName: value });
                            }
                        } }),
                    React.createElement(DropDownTrigger, null)),
                React.createElement(SelectField, { value: this.state.ticketType, style: styles.select, floatingLabelFixed: true, floatingLabelText: "T\u00EDpus", onChange: function (e, _, value) { return _this.handleChange("ticketType", value); } }, ticketTypes.map(toMenuItem)),
                React.createElement(SelectField, { value: this.state.product, style: styles.select, floatingLabelFixed: true, floatingLabelText: "Term\u00E9k", onChange: function (e, _, value) { return _this.handleChange("product", value); } }, products.map(toMenuItem)),
                React.createElement(SelectField, { value: this.state.competency, style: styles.select, floatingLabelFixed: true, floatingLabelText: "Kompetencia", onChange: function (e, _, value) { return _this.handleChange("competency", value); } }, competencies.map(toMenuItem)),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Le\u00EDr\u00E1s", multiLine: true, onChange: function (e, value) { return _this.handleChange("description", value); } }),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Megjegyz\u00E9s", multiLine: true, onChange: function (e, value) { return _this.handleChange("note", value); } }),
                React.createElement(Checkbox, { label: "Sprintenk\u00E9nt ism\u00E9tl\u0151d\u0151 feladat?", labelStyle: { fontSize: '12px', color: 'rgba(0,0,0,.54)' }, checked: this.state.periodic, onCheck: function (_, checked) { return _this.handleChange("periodic", checked); } }))));
    };
    TaskForm = tslib_1.__decorate([
        inject('userStore', 'taskStore', 'projectStore'),
        observer
    ], TaskForm);
    return TaskForm;
}(React.Component));
export default TaskForm;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskForm.tsx
// module id = 780
// module chunks = 0